import { render, staticRenderFns } from "./RelatorioHistoricoJobs.vue?vue&type=template&id=f11f4e1c"
import script from "./RelatorioHistoricoJobs.vue?vue&type=script&lang=js"
export * from "./RelatorioHistoricoJobs.vue?vue&type=script&lang=js"
import style0 from "./RelatorioHistoricoJobs.vue?vue&type=style&index=0&id=f11f4e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports